import { lazy, Suspense } from 'react'
import { PlayScreen } from './PlayScreen'
import { Home } from './Home'
import { JoinByCode } from './JoinByCode'
import './multiplayer.css'

// The production client never loads local rules, authoritative state or replay tooling.
const LocalPlayground = import.meta.env.DEV ? lazy(() => import('./LocalPlayground')) : null

export function App() {
  const play = location.pathname.match(/^\/(?:play|rooms?)\/([a-zA-Z0-9_-]+)\/?$/)?.[1]
  if (play) return <PlayScreen key={play} roomId={play}/>
  const code = location.pathname.match(/^\/join\/([a-zA-Z0-9]+)\/?$/)?.[1]
  if (code) return <JoinByCode code={code}/>
  if (LocalPlayground && new URLSearchParams(location.search).get('game') !== 'online') {
    return <Suspense fallback={<div role="status" className="pg-loading">Opening your local table…</div>}><LocalPlayground/></Suspense>
  }
  return <Home/>
}
